module.exports = __webpack_public_path__ + "img/instagram.becea118.png";